import React, { ReactNode, useState } from "react";
import { InvoiceData, PaymentData } from "./types";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { formatDate } from "../index";

const initialInvoiceData: InvoiceData[] = [
  {
    depositDate: "21 Feb, 2023",
    email: "dolores.chambers@example.com",
    depositAmount: 10680,
    bankName: "Chase Bank",
    accountNumber: "1234567890",
    accountHolderName: "Dolores Chambers",
    routingNumber: "021000021",
  },
  {
    depositDate: "21 Feb, 2023",
    email: "dolores.chambers@example.com",
    depositAmount: 10680,
    bankName: "Chase Bank",
    accountNumber: "1234567890",
    accountHolderName: "Dolores Chambers",
    routingNumber: "021000021",
  },
  {
    depositDate: "21 Feb, 2023",
    email: "dolores.chambers@example.com",
    depositAmount: 10680,
    bankName: "Chase Bank",
    accountNumber: "1234567890",
    accountHolderName: "Dolores Chambers",
    routingNumber: "021000021",
  },
  {
    depositDate: "21 Feb, 2023",
    email: "dolores.chambers@example.com",
    depositAmount: 10680,
    bankName: "Chase Bank",
    accountNumber: "1234567890",
    accountHolderName: "Dolores Chambers",
    routingNumber: "021000021",
  },
];

interface InvoicesTabProps {
  invoices: PaymentData[];
}

const InvoicesTab: React.FC<InvoicesTabProps> = ({ invoices }) => {
  const [sortedInvoices, setSortedInvoices] = useState<PaymentData[]>([]);

  // const columns: ColumnsType<PaymentData> = [
  const columns: any = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      // render: (value: string) => formatDate(value),
      width: "5%",
      sorter: (a: any, b: any) =>
        a.id - b.id,
      defaultSortOrder: "descend",
    },
    {
      title: "Payment Email",
      dataIndex: "paymentEmail",
      key: "paymentEmail",
      // render: (value: string) => formatDate(value),
      width: "10%",
      sorter: (a: any, b: any) =>
        a.paymentEmail.localeCompare(b.paymentEmail),
    },
    {
      title: "Account Email",
      dataIndex: "accountEmail",
      key: "accountEmail",
      // render: (value: string) => formatDate(value),
      width: "10%",
      sorter: (a: any, b: any) =>
        a.paymentEmail.localeCompare(b.paymentEmail),
    },
    {
      title: "Bank name",
      dataIndex: "bankName",
      key: "bankName",
      // render: (value: string) => formatDate(value),
      width: "12%",
      sorter: (a: any, b: any) =>
        a.bankName.localeCompare(b.bankName),
    },
    {
      title: "Holder Name",
      dataIndex: "accountHolderName",
      key: "accountHolderName",
      width: "12%",
      align: "center",
      sorter: (a: any, b: any) => a.accountHolderName.localeCompare(b.accountHolderName),
    },
    {
      title: "Account Number",
      dataIndex: "accountNumber",
      key: "accountNumber",
      // render: (value: number) => `$${Number(value).toFixed(2)}`,
      width: "15%",
      align: "right",
      sorter: (a: any, b: any) => a.accountNumber.localeCompare(b.accountNumber),
    },
    {
      title: "Routing Number",
      dataIndex: "routingNumber",
      key: "routingNumber",
      // render: (value: number) => `$${Number(value).toFixed(2)}`,
      width: "15%",
      align: "right",
      sorter: (a: any, b: any) => a.routingNumber.localeCompare(b.routingNumber),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      // render: (value: number) => `$${Number(value).toFixed(2)}`,
      width: "5%",
      align: "right",
      sorter: (a: any, b: any) => a.id - b.id,
    },

    // id
    //   paymentEmail
    //   bankName
    //   accountHolderName
    //   accountNumber
    //   routingNumber
    //   amount
    // {
    //   title: "Bank Name",
    //   dataIndex: "bankName",
    //   key: "bankName",
    // },
    // {
    //   title: "Account Number",
    //   dataIndex: "accountNumber",
    //   key: "accountNumber",
    // },
    // {
    //   title: "Account Holder Name",
    //   dataIndex: "accountHolderName",
    //   key: "accountHolderName",
    // },
    // {
    //   title: "Routing Number",
    //   dataIndex: "routingNumber",
    //   key: "routingNumber",
    // },
  ];

  return (
    <div className="invoices-table">
      <Table<PaymentData>
        dataSource={invoices && invoices.length > 0 ? invoices : sortedInvoices}
        columns={columns}
        rowKey="accountNumber"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`,
        }}
        tableLayout="fixed"
      />
    </div>
  );
};

export default InvoicesTab;
